module.exports = __webpack_public_path__ + "img/seat.e0115b3c.png";